import { motion } from "framer-motion";

export default function Reel() {
  return (
    <section id="reel" className="scroll-mt-24 py-24 sm:py-32">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-10 flex flex-col items-center text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.8 }}
          className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.3em] text-rust mb-5 flex items-center gap-3"
        >
          <span className="w-8 h-px bg-rust inline-block" />
          From the oven — in motion
          <span className="w-8 h-px bg-rust inline-block" />
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02] mb-12 sm:mb-16"
        >
          The <span className="italic text-rust">pull apart.</span>
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: 36, scale: 0.97 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="relative"
        >
          <div className="w-[74vw] max-w-[330px] sm:max-w-[380px] aspect-[9/16] rounded-[28px] overflow-hidden border-[5px] border-ink shadow-[12px_12px_0_#D4A359]">
            <video
              autoPlay
              muted
              loop
              playsInline
              data-testid="reel-video"
              className="w-full h-full object-cover"
            >
              <source src="/videos/bake-reel.mp4" type="video/mp4" />
              <source src="/videos/bake-reel.webm" type="video/webm" />
            </video>
          </div>
          <p className="mt-5 font-mono text-[10px] uppercase tracking-[0.25em] text-mutedbrown">
            Reel 01 — Focaccia, torn while still warm · Dadar, Mumbai
          </p>
        </motion.div>
      </div>
    </section>
  );
}
